import "../../css/portfolio.css";
import PortfolioNavigation from './PortfolioNavigation';

function Portfolio() {
  return (
    <div>
      <PortfolioNavigation />
    </div>
  )
}

export default Portfolio
